// ContactPage.jsx - Updated with separate components
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageBanner from '../../../components/customer/pagebanner/PageBanner';
import ContactInfoSection from '../../../subscreens/customer/contact/contactinfosection/ContactInfoSection';
import MapSection from '../../../subscreens/customer/contact/contactmapsection/ContactMapSection';
import FAQSection from '../../../subscreens/customer/contact/faqsection/FAQSection';
import '../../../assets/css/customer/screens/ContactUs.css';
import MyNavbar from '../../../components/general/mynavbar/MyNavbar';
import Footer from '../../../components/general/footer/Footer';
import useScrollToTop from "../../../contexts/UseScrolltoTop";
const ContactPage = () => {
  useScrollToTop();
  return (
    <>
    <MyNavbar />
    <div className="contact-page" >
      {/* Page Banner */}
      <PageBanner
        title="Contact Us"
        subtitle="Have questions? We'd love to hear from you. Send us a message!"
        buttonText="Get In Touch"
        buttonLink="#contact-form"
        breadcrumbs={[
          { label: 'Contact Us' }
        ]}
      />

      {/* Contact Info Cards */}
      <ContactInfoSection />

      {/* Form and Map Section */}
      <section className="form-map-section">
        <Container>
          <Row className="form-map-wrapper">
            <Col lg={6} md={12}>
              <MapSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
      <FAQSection />
    </div>
    <Footer />
    </>
  );
};

export default ContactPage;